// @generated by TypeGen from LogbookApi/AnchorWatchApi - DO NOT EDIT

import type { IAnchorWatchRequest } from "../LogbookApp/AnchorWatchApi"
import type { IAppResponse } from "../LogbookApp/Routes"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface AnchorWatchApiEndpoints {
  "PUT /api/ship/anchor/watch": {
    params: {};
    query: {};
    request: IAnchorWatchRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
}

export const anchorWatchApiEndpoints = {
  "PUT /api/ship/anchor/watch": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
} as const;

export class AnchorWatchApi {
  constructor(private client: ApiClient) {}

  anchorWatch = {
    update: (a: ApiArgs<AnchorWatchApiEndpoints, "PUT /api/ship/anchor/watch">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "PUT /api/ship/anchor/watch", anchorWatchApiEndpoints["PUT /api/ship/anchor/watch"].targets);
        return this.client.call<IAppResponse>("PUT /api/ship/anchor/watch", a);
      },
      url: (): string => this.client.url("PUT /api/ship/anchor/watch", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.editCurrent,
    }),
  };
}
